import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { LoginService } from '../services/login.service';
import { ModalComponent } from '../shared/dialog/modal/modal.component';
import { DialogService } from '../shared/services/dialog-service';
import { HomeService } from '../shared/services/home.service';
import { PanelListService } from '../shared/services/panel-list.service';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';

declare let $: any;


@Component({
  selector: 'app-panel-list',
  templateUrl: './panel-list.component.html',
  styleUrls: ['./panel-list.component.scss'],
})
export class PanelListComponent implements OnInit, OnDestroy {

  isFillView: boolean = false;
  showTableData: boolean = true;
  ipsos_panel: boolean = false;
  isLoading: boolean = true;
  isData: boolean = false;
  isError: boolean = false;
  showDuplicate: boolean = false;
  showConfirm: boolean = false;
  trueFace: boolean;
  isDuplicateAccess: boolean = false;
  isVisibility: boolean;
  isRowChecked:boolean = false;
  isColChecked:boolean = false;

  tableData: any = [];
  tablePanel: any = [];
  subList: any = [];
  tableHeadPrint: string[];
  projectName: string;
  tableRowPrint: any = [];
  list: any = [];
  tableHeader: any = [];
  panelDetails: any = [];
  panelIpsos: any = [];
  indexTable: any = { rowIndex: [], colIndex: [] };
  pane: any;
  selectedRowObj: any;
  currFinalTableHtml: string;
  finalTableHtml: string;
  errorText: string = 'No Data Found !';
  duplicatePopupImg: string;

  // studyId: string = '3f63be94-a77e-4ccb-ab45-37f42a77e3f9';
  studyId: string;
  pageNo: number = 0;
  limit: number = 50;
  confirmMsg: string;
  respondVal: number;
  respondId: number;
  totalResponses: number = 0;
  uniqueResponse: number = 0;
  selectedRecruiter: string = 'noId';
  selectedStatus: string = 'noId';
  selectedCity: string = 'noId';
  resPageIpsos: number = 0;
  filterOptionCity: any = [];
  filterOptionStatus: any = [];
  studyVisibility: any;
  responseDataQuota: any;
  cityList: any;
  recruiters: any = [{ key: 'all', value: 'All Recruiter' }];
  fullViewData: any;
  userId: string;
  currentResponce: number = 0;
  rootProjectName: string = "";
  rootProjectUrl: string = "";
  performaceTrackerData: any = [];
  accessRoles: any = [];
  detailsNameFull: string;
  detailsName: string = "";
  public statusaction:any=[];
  public datasource: any;

  // scroll pagination
  throttle = 150;
  scrollDistance = 2;
  pageData = {pageNo: 0, pageLimit: 50};




  constructor(
    private panelService: PanelListService,
    private activeRoute: ActivatedRoute,
    private notifier: NotifierService,
    private dialogService: DialogService,
    private router: Router,
    private sidePanel:SidePanelService,
    private logerror: LoginService,
    private homeService: HomeService,
    private dialog: MatDialog
  ) {
    // this.notifier = notifier;
    this.dialogService.tableData;
    this.dialogService.imgUrl = '';
    this.dialogService.isData = 'print';
    this.homeService.sidenav2Open.next(true);
  }

  ngOnDestroy() {
    // this.snackBar.dismiss();
    this.hideAllNotifications();
  }
  ngOnInit() {
    let access = JSON.parse(localStorage.getItem('access'));
    if (access['access_rules']['panel_list']) {
      this.isDuplicateAccess = access['access_rules']['panel_list']['duplicate_check'];
    }
    this.activeRoute.params.subscribe((params) => {
      this.studyId = params['id'];
    });
    this.dialogService.studyId = this.studyId;
    this.sidePanel.initSideDrawer(localStorage.getItem('studyTYPE'));
    // this.sidePanel.initSideDrawer(sessionStorage.getItem('studyTYPE'));
    this.sidePanel.getVisibility(this.studyId);
    this.getStudyVisiblity();
    // this.getPanelDetails();
    // this.getPanelIpsos();
    this.getResponseDataQuota();
    this.getCityList();
    this.homeService.checkRepoDetailsEvent.emit(this.studyId);
  }
  toggleFullView() {
    this.isFillView = !this.isFillView;
  }

  getKeyByValue(tableHeader: any, value: string) {
    return Object.keys(tableHeader).find(function (key) { return tableHeader[key] && (("" + tableHeader[key]).toLowerCase() === ("" + value).toLowerCase()) }) || 1;
  }

  resetData() {
    this.isLoading = true;
    this.isData = true;
    this.selectedRecruiter = 'noId';
    this.selectedStatus = 'noId';
    this.selectedCity = 'noId';
    this.filterOptionCity = [];
    this.filterOptionStatus = [];
    this.indexTable['colIndex'] = [];
    this.indexTable['rowIndex'] = [];
    this.tableHeadPrint = [];
    this.tableRowPrint = [];
    this.selectedRowObj = [];
    this.getPanelIpsos();
  }
  
  applyChanges() {
    this.getPanelIpsos();
  }

  updateStatus() {
    if (this.filterOptionStatus.indexOf('all') !== -1) {
      this.filterOptionStatus = ['all', '0', '1', '2', '3'];
    } else {
    }
  }

  updateCity() {
    if (this.filterOptionCity.indexOf('all') !== -1) {
      this.filterOptionCity = ['all', '0', '1', '2', '3'];
    } else {
    }
  }

  showDuplicateImage(img: string) {
    this.showDuplicate = !this.showDuplicate;
    this.duplicatePopupImg = img;
  }

  confirmRespondent(id, mode: any) {
    this.respondId = id;
    this.respondVal = mode;
    if (this.respondVal === 1) {
      this.confirmMsg = 'Are you sure you want to accept this duplicate entry? This action cannot be reversed.';
    }
    else {
      this.confirmMsg = 'Are you sure you want to reject this duplicate entry? This action cannot be reversed.';
    }
    this.dialogService.confirmMsg = this.confirmMsg;
    this.dialogService.id = this.respondId;
    this.dialogService.mode = this.respondVal;
    this.dialogService.isData = 'confirm';
    // this.hideConfirm();
    this.openDialogConfirm();
  }

  // hideConfirm(){
  //   this.showConfirm = !this.showConfirm;
  // }

  specificUser() {
    this.pane = [];
    this.totalResponses = 0;
    this.uniqueResponse = 0;
    if (this.selectedRecruiter === 'all') {
      Object.keys(this.panelIpsos.result).forEach((data: any) => {
        Object.keys(this.panelIpsos.result[data]).forEach((list) => {
          this.pane.push(this.panelIpsos.result[data][list]);
          this.totalResponses += 1;
          if (this.panelIpsos.result[data][list]['face_status'] === 1) {
            this.uniqueResponse += 1;
          }
        });
      });
      if (this.pane) {
        this.isData = true;
      } else {
        this.isData = false;
      }
    } else if (this.selectedRecruiter !== 'noId') {
      this.userId = this.selectedRecruiter;
      this.pane = this.panelIpsos.result[this.userId];
      if (this.pane) {
        for (let i = 0; i < this.pane.length; i++) {
          this.totalResponses += 1;
          if (this.pane[i]['face_status'] === 1) {
            this.uniqueResponse += 1;
          }
        }
        this.isData = true;
      } else {
        this.isData = false;
      }
    } else {
      this.recruiters = [{ key: 'all', value: 'ALL Recruiter' }];
      Object.keys(this.panelIpsos.result).forEach((data: any) => {
        this.recruiters.push({ key: data, value: this.panelIpsos.result[data][0]['recruiter_name'] });
        Object.keys(this.panelIpsos.result[data]).forEach((list) => {
          this.pane.push(this.panelIpsos.result[data][list]);
          this.totalResponses += 1;
          if (this.panelIpsos.result[data][list]['face_status'] === 1) {
            this.uniqueResponse += 1;
          }
        });
      });
    }
    // this.indexTable['colIndex'] = [];
    this.indexTable['rowIndex'] = [];
    // this.tableHeadPrint = [];
    this.tableRowPrint = [];
    this.selectedRowObj = [];
  }

  getPanelDetails() {
    this.panelService.getPanelDetails(this.studyId, this.pageData['pageNo'], this.pageData['pageLimit']).subscribe((data) => {
      this.trueFace = false;
      if (Object.keys(data.result.result).length !== 0) {
        this.tablePanel = data.result.result;
        if (this.trueFace === false) {
          this.isData = true;
        }
      } else {
        if (this.trueFace === false) {
          this.errorText = 'No Data Found';
          this.isData = false;
          this.isError = false;
        }
      }
      this.isLoading = false;
    },
      (error) => {
        if (this.trueFace === false) {
          if (error.status === 403) {
            this.router.navigate(['home/access-denied']);
          } else if (error.status === 401) {
            this.errorText = 'User is not authorised';
            this.isError = true;
            this.isData = true;
            this.isLoading = false;
            this.router.navigate(['home/access-denied']);
          }
          else {
            if (this.trueFace === false) {
              this.errorText = 'Something Went Wrong !';
              this.isData = true;
              this.isError = true;
            }
          }
        }
      });
  }

  getPanelIpsos() {
    if (this.filterOptionStatus.indexOf('all') !== -1) {
      this.filterOptionStatus = [];
      this.filterOptionStatus.splice(this.filterOptionStatus.indexOf('all'), 1);
    }
    if (this.filterOptionCity.indexOf('all') !== -1) {
      this.filterOptionCity = [];
      this.filterOptionCity.splice(this.filterOptionCity.indexOf('all'), 1);
    }
    this.isLoading = true;
    this.panelService.getPanelIpsos(this.studyId, this.filterOptionCity, this.filterOptionStatus)
      .subscribe((data) => {

        this.trueFace = true;
        if (Object.keys(data.result).length !== 0) {
          this.panelIpsos = data;
          this.tableHeader = data.tableheaders;
          this.fullViewData = [this.studyId];
          this.fullViewData[this.studyId] = [this.getKeyByValue(this.tableHeader, 'selfie'), this.getKeyByValue(this.tableHeader, 'name'), this.getKeyByValue(this.tableHeader, 'gender'), this.getKeyByValue(this.tableHeader, 'age'), this.getKeyByValue(this.tableHeader, 'city'), this.getKeyByValue(this.tableHeader, 'SECAutoCalc')];
          this.specificUser();
          this.ipsos_panel = data['recruit'];
          this.resPageIpsos = 1;

          for (let i = 0; i < Object.keys(this.panelIpsos.result).length; i++) {
            let userResult = this.panelIpsos.result[Object.keys(this.panelIpsos.result)[i]];
            for (let j = 0; j < userResult.length; j++) {
              let userResultResNew = {};
              let userResultRes = userResult[j].response;
              for (let k = 0; k < userResultRes.length; k++) {
                let currMisc = JSON.parse(userResultRes[k].miscellaneous);
                if (currMisc && currMisc.rank) {
                  userResultRes[k].option_text = currMisc.rank;
                };
                if (userResultResNew[userResultRes[k].question_id]) {
                  userResultResNew[userResultRes[k].question_id] = userResultRes[k];
                } else {
                  userResultResNew[userResultRes[k].question_id] = [];
                  userResultResNew[userResultRes[k].question_id] = userResultRes[k];
                };
              };
              userResult[j].response = userResultResNew;
            }
          }
          if (this.trueFace === true) {
            this.isError = false;
            this.isData = true;
          }
        } else {
          if (this.trueFace === true) {
            this.errorText = 'No Data Found';
            this.isData = false;
            this.isError = false;
          }
        }
        this.isLoading = false;
      },
        (error) => {
          this.isLoading = false;
          if (this.trueFace === true) {
            if (error.status === 403) {
              this.router.navigate(['home/access-denied']);
            } else if (error.status === 401) {
              this.errorText = 'User is not authorised';
              this.isError = true;
              this.isData = true;
              this.router.navigate(['home/access-denied']);
            }
            else {
              if (this.trueFace === true) {
                this.errorText = 'Something Went Wrong !';
                this.isData = true;
                this.isError = true;
              }
            }
          }
        }
      );
  }

  getResponseDataQuota() {
    this.panelService.getResponceDataQuota(this.studyId).subscribe((data) => {
      this.responseDataQuota = data.result;
      if (data.status == 1 && data.result) {
        let value = data.result;
        this.projectName = value.projects.projects && value.projects.projects[0].name || null;
        this.currentResponce = data.result['responses'];
        this.detailsName = data.result['details']['name'].length > 80 ? data.result['details']['name'].slice(0, 80) + '...' : data.result['details']['name'];
        this.detailsNameFull = data.result['details']['name'];
        if (data.result['projectOfStudies']) {
          this.rootProjectName = data.result['projectOfStudies']['name'];
          this.rootProjectUrl = data.result['projectOfStudies']['uuid'];
        }
      }
    },
      (error) => {
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        } else if (error.status === 401) {
          this.errorText = 'User is not authorised';
          this.isError = true;
          this.isData = true;
          this.router.navigate(['home/access-denied']);
        }
      });
  }

  getStudyVisiblity() {
    this.panelService.getStudyVisiblity(this.studyId).subscribe((data) => {
      if (data.data) {
        const str = JSON.parse(JSON.stringify(data));
        if (JSON.parse(str.data).trueFace && JSON.parse(str.data).trueFace.show) {
          this.getPanelIpsos();
          // this.trueFace = JSON.parse(str.data).trueFace.show;
        } else {
          this.getPanelDetails();
          // this.trueFace = false;
        }
        if (JSON.parse(str.data)['panelList'] && JSON.parse(str.data)['panelList']['show']) {
          this.isVisibility = JSON.parse(str.data)['panelList']['show'];
        } else {
          this.isVisibility = false;
          this.errorText = 'User is not authorised';
          this.isError = true;
          this.isData = true;
        }
      }
    });
  }
  
  getCityList() {
    this.panelService.getCityList(this.studyId).subscribe((data) => {
      if (data.result) {
        this.cityList = data.result;
      }
    });
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }
  public hideAllNotifications(): void {
    this.notifier.hideAll();
  }

  exportDataTable() {
    this.getRowAndCol();
    if (this.indexTable['colIndex'].length === 0 || this.indexTable['rowIndex'].length === 0) {
      this.showNotification('error', 'Please select the Columns and Rows first');
    } else {
      this.dialogService.tableIndex = this.indexTable;
      this.dialogService.isData = 'print';
      this.exportDataTableSelect();
      this.openDialog();
    }
  }

  duplicateImage(url: string, id?:number, status?:number, faceId?:number,index?:number) {
    this.dialogService.imgUrl = url;
    this.dialogService.isData = 'img';
   this.openDialogDupli(id, status,faceId);
  }

  openDialogDupli(id?:number, status?:number, trueDaceId?:number) {
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '55vw',
      height: '60vh',
      data:{imageStatus:status, dupId:id}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.type == 'img' && status == 0){
        this.confirmRespondent(trueDaceId,result.duplicate);
      }
      if(result.type == 'error'){
        this.showNotification('error',result.error);
      }
    });
  }

  showImages(id?: number) {
    this.dialogService.isData = 'listImg';
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '60vw',
      height: '85vh',
      data:{userId:id}
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '80vw',
      height: '85vh'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogConfirm(): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '380px',
      height: '150px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !=undefined && result.type=='update') {
        this.pane.forEach((element,index) => {
          if(element['face_id']==this.respondId) {
           if(this.respondVal==1){
             this.pane[index]['face_status']=2;
           }else{
           this.pane[index]['face_status']=3;
          }
           }
         });
      }
    });
  }

  getRowAndCol() {
    //check row coll
    for (let j = 0; j < $('#tableData tbody tr td mat-checkbox input:checked').length; j++) {
      let currIndex = $('#tableData tbody tr td mat-checkbox input:checked').eq(j).closest('tr').index();
      let currRow = $('#tableData tbody tr td mat-checkbox input:checked').eq(j).closest('tr');
      let page = this.resPageIpsos - 1;
      let clickedName = 10 * page + currIndex;

      if (currRow.find('td input:checked.rowSelect').prop('checked')) {
        let tempHTML = '';
        for (let i = 0; i < currRow.closest('tr').children('td.selectable').length; i++) {
          if (currRow.closest('tr').children('td.selectable').eq(i).children('code').length > 0) {
            tempHTML += '<td>' + currRow.closest('tr').children('td.selectable').eq(i).children('code').html().trim() + '</td>';
          }
          else {
            tempHTML += '<td>' + currRow.closest('tr').children('td.selectable').eq(i).html().trim() + '</td>';
          };
        };
        this.selectedRowObj[clickedName] = '<tr>' + tempHTML + '</tr>';
      };

    };
  }

  columnCheck(data: string) {
    if (this.indexTable['colIndex'].indexOf(data) === -1) {
      this.indexTable['colIndex'].push(data);
    } else {
      const index = this.indexTable['colIndex'].indexOf(data, 0);
      if (index > -1) {
        this.indexTable['colIndex'].splice(index, 1);
      }
    }
    setTimeout(function () {
      $('#tableData .selectable').removeClass('selectable');
      for (let i = 0; i < $('#tableData tbody tr th mat-checkbox input:checked').length; i++) {
        $('#tableData tbody tr th mat-checkbox input:checked').eq(i).closest('th').addClass('selectable');
      };
    });
  }

  rowCheck(data: string) {
    if (this.indexTable['rowIndex'].indexOf(data) === -1) {
      this.indexTable['rowIndex'].push(data);
    } else {
      const index = this.indexTable['rowIndex'].indexOf(data, 0);
      if (index > -1) {
        this.indexTable['rowIndex'].splice(index, 1);
      }
    }
  }

  checkSelectedRows() {
    setTimeout(function () {
      let selected = Object.keys(this.selectedRowObj);
      for (let i = 1; i < $('#tableData tbody tr').length; i++) {
        let currItem = $('#tableData tbody tr').eq(i).children('td:first-child').text().trim();
        if (selected.indexOf(currItem) != -1) {
          $('#tableData tbody tr').eq(i).children('td:first-child').children('input:checkbox').prop('checked', true);
        };
      };
    })
  };

  rowCheckPrint(event: any) {
    if (!this.selectedRowObj) {
      this.selectedRowObj = {}
    }

    let currIndex = $(event.currentTarget).closest('tr').index();
    let page = this.resPageIpsos - 1;
    let clickedName = 10 * page + currIndex;
    let currRow = $(event.currentTarget).closest('tr').html();
    if ($(event.currentTarget).prop('checked')) {
      this.selectedRowObj[clickedName] = '<tr>' + currRow + '</tr>';
    } else {
      delete this.selectedRowObj[clickedName];
    }
  }

  exportDataTableSelect() {
    let tableHeadRow = '<th>S.NO</th>';
    this.tableHeadPrint = [];
    this.tableRowPrint = [];
    let selectableCols = [];
    for (let i = 0; i < $('#tableData').find('tbody tr th.selectable').length; i++) {
      let currRow = $('#tableData').find('tbody tr th.selectable').eq(i);
      const head = currRow.attr('id');
      this.tableHeadPrint.push(head);
      tableHeadRow += '<th>' + currRow.attr('id') + '</th>'
      selectableCols.push(currRow.index());
    }
    let TableHeadHtml = '<thead><tr>' + tableHeadRow + '</tr></thead>';
    this.currFinalTableHtml = '';
    for (let i = 0; i < Object.keys(this.selectedRowObj).length; i++) {
      let currKey = Object.keys(this.selectedRowObj)[i];
      let currHtml = this.selectedRowObj[currKey];
      let el: any = document.createElement('tr');
      currHtml = currHtml.trim().replace(/<!--[\s\S]*?-->/g, '').replace(/\>\s+\</g, '><');
      currHtml = currHtml.substr(4, currHtml.length);
      currHtml = currHtml.substr(0, currHtml.length - 5);
      el.innerHTML = currHtml;
      el = $(el);

      $(el).children('td').removeClass('selectable');
      for (let j = 0; j < selectableCols.length; j++) {
        el.children('td').eq(selectableCols[j]).addClass('selectable');
      };

      let tempHTML = '<td>' + (i + 1) + '.</td>';
      let row: string;
      let rowSelected: string[] = [];
      for (let j = 0; j < $(el).children('td.selectable').length; j++) {
        row = '';
        if (el.children('td.selectable').eq(j).children('code').length > 0) {
          row = $(el).children('td.selectable').eq(j).children('code').html().trim();
          rowSelected.push(row);
          tempHTML += '<td>' + $(el).children('td.selectable').eq(j).children('code').html().trim() + '</td>';
        } else {
          row = $(el).children('td.selectable').eq(j).html().trim();
          rowSelected.push(row);
          tempHTML += '<td>' + $(el).children('td.selectable').eq(j).html().trim() + '</td>';
        };
      };

      if (tempHTML) {
        this.tableRowPrint.push(rowSelected);
        this.currFinalTableHtml += '<tr>' + tempHTML + '</tr>';
      };
    };

    this.finalTableHtml = '<table id="printableTable" class="table">' + TableHeadHtml + '<tbody>' + this.currFinalTableHtml + '</tbody></table>';

    this.dialogService.tableData = { 'tableHead': this.tableHeadPrint, 'tableData': this.tableRowPrint };
    this.dialogService.tableFormate = this.finalTableHtml;
  }

  recruiterMenu(type) {
    if (type === 'all') {
      this.router.navigate(['/home/projects']);
    } else {
      this.router.navigate(['/home/projects', this.rootProjectUrl]);
    }
  }

  selectCol() {
    // setTimeout(function () {
      if(!this.isColChecked){
        $('#tableData .selectable').removeClass('selectable');
          $('#tableData tbody tr th mat-checkbox input:checked').click();
          $('#tableData tbody tr th mat-checkbox input').click();
        }else{
          $('#tableData .selectable').removeClass('selectable');
          $('#tableData tbody tr th mat-checkbox input:checked').click();
        }
      // });
      this.columnCheck('Picture');
      this.isColChecked = !this.isColChecked;
    }

  selectRow() {
    if(!this.isRowChecked){
      $('#tableData tbody tr td input:checked').click();
      $('#tableData tbody tr td input').click();
    }else{
      $('#tableData tbody tr td input:checked').click();
    }
    this.isRowChecked = !this.isRowChecked;
  }

  onScrollUsers() {
    this.pageData['pageNo']++;
    this.panelService.getPanelDetails(this.studyId, this.pageData['pageNo'], this.pageData['pageLimit']).subscribe((data) => {
      if (Object.keys(data.result.result).length !== 0) {
        this.datasource = data.result.result;
        if (this.pageData['pageNo'] === 0) {
          this.tablePanel = this.datasource;
        } else {
          this.tablePanel = [...this.tablePanel, ...this.datasource];
        }
      } 
    },
      (error) => {
        if (this.trueFace === false) {
          if (error.status === 403) {
            this.router.navigate(['home/access-denied']);
          } else if (error.status === 401) {
            this.errorText = 'User is not authorised';
            this.isError = true;
            this.isData = true;
            this.isLoading = false;
          }
          else {
            if (this.trueFace === false) {
              this.errorText = 'Something Went Wrong !';
              this.isData = true;
              this.isError = true;
            }
          }
        }
      });
  }

 


}